function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeasure = function SvgMeasure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 400 400"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m57.78 208.19 46.16-8.4 37.76-33.56 43.36 8.39 32.17 55.94 36.45 13.64 24.38 50.02 45.38 30.93",
    style: {
      fill: "none",
      stroke: "#009e7d",
      strokeLinejoin: "bevel",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.10000000149011612
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.93,
    cy: 301.68,
    rx: 25.09,
    ry: 2.84,
    style: {
      fill: "#222"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.41 252.43s0 12.79 4.5 17.05 13.26 7.1 16.34 5 5.2-7.81 1.42-12.07S145.25 256.7 141 256a17.67 17.67 0 0 1-7.59-3.57ZM188.1 261.67s-8-4.26-14-3.55-10.41 3.55-11.83 8.52 1.65 8.05 5.2 9.23c3.79 1.42 8 0 11.13-5.68 2.87-5.45 9.5-8.52 9.5-8.52Z",
    style: {
      fill: "#23c388"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09 300.26s1.42 2.84 5.21 0c0 0-1.42-9.95-1.42-12.79a16.57 16.57 0 0 1 .71-7.81c1.42-3.55 8-9.23 9.7-10.65s4.5-3.56 2.84-3.56-5.21 1.43-8.76 5a78 78 0 0 0-6.63 7.1s-3.78-7.1-5.91-9.23-8.05-8.53-10.42-7.11 3.79 4.26 5.21 5.69 8 10.65 9 13.49c.47 2.82.47 19.87.47 19.87Z",
    style: {
      fill: "#009e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.19 329.38v-79s3.76-3.76 7.52 0v79s0 3.76-7.52 0Z",
    style: {
      fill: "#cdc3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.31 265.46-37.6-12.03v33.09l37.6-21.06z",
    style: {
      fill: "#23c388"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.10000000149011612
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.94,
    cy: 196.33,
    rx: 32.43,
    ry: 3.08,
    style: {
      fill: "#222"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m246.58 111.33 28.17 49s2.37 1.18 1.89-.71-15.86-41.9-15.86-41.9-5 1.42-7.1-.48-4.74-6.63-4.74-6.63Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.55 118.91.47 77.18s-2.37 2.6-8.28 0l1.89-77.18Z",
    style: {
      fill: "#9da6aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.42 111.33-56.35-.71s-2.13 1.42-.47 1.9c1.89.47 44 7.81 44 7.81s1.42-5 4-5.92a43.83 43.83 0 0 1 8-.71Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.42 115.12 28.64-48.53s-.23-2.6-1.65-1.18-28.65 34.32-28.65 34.32 3.55 3.79 3.08 6.4a38.68 38.68 0 0 1-3.32 7.33Z",
    style: {
      fill: "#b2bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.68 118.91H244v-9s-.23-2.36 2.84-2.36h4s2.6 0 2.6 2.36c.24 2.09.24 9 .24 9Z",
    style: {
      fill: "#d7dcde"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.94,
    cy: 113.23,
    r: 4.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.91 84.28c2.82 10.07 0 239.37 0 239.37S334.8 317.3 334 329.08 49.69 334 49.69 334l3.37-249.73s5.45-8.51 7.85.01Z",
    style: {
      fill: "#e9e3dc"
    }
  }));
};
export default SvgMeasure;